import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
var CommissionMonoHtmlView = function (props) {
    var deviation = props.deviation, link = props.config.link;
    return (React.createElement(EditorDeviationLink, { link: link, deviation: deviation, linkClass: "gallery-link" },
        React.createElement("div", { className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation), props.config &&
                props.config.alignment &&
                "daeditor-align-".concat(props.config.alignment), props.settings &&
                props.settings.showMediaAlwaysSmall &&
                "daeditor-small") },
            React.createElement("div", { className: "daeditor-freeform-header" },
                React.createElement("span", { className: "daeditor-freeform-title" }, getDeviationTitle(deviation))))));
};
CommissionMonoHtmlView.displayName = 'CommissionMonoHtmlView';
export default CommissionMonoHtmlView;
//# sourceMappingURL=CommissionHtml.js.map